import { useContext, useEffect, useRef } from "react";
import { CachedTokenContext } from "@seabrookstudios/auth";
import { s2Url } from "@seabrookstudios/types";
import endpoints from "../endpoints";
import { useQueryClient } from "@tanstack/react-query";
import { GameById } from "@seabrookstudios/pitch2table";
import { useSnackbar } from "notistack";
import { useUploadImage } from "../users/queries";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {File} props.coverFile
 * @param {() => void} props.onStart
 * @param {() => void} props.onComplete
 * @param {() => void} props.onError
 */
export const GameImportCoverUpload = ({ gameId, coverFile, onStart, onComplete, onError }) => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const token = useContext(CachedTokenContext);
  const hasStarted = useRef(false);

  const onFileUploadSuccess = async () => {
    enqueueSnackbar("Cover updated", { variant: "success" });
    await queryClient.invalidateQueries({ queryKey: GameById(gameId) });
    onComplete();
  };

  const onFileUploadFailure = () => {
    enqueueSnackbar("An error occurred uploading the avatar", { variant: "error" });
    onError();
  };

  const { games } = endpoints();
  const url = games().cover(gameId);
  const uploadImage = useUploadImage(s2Url(url), token, "cover", onFileUploadSuccess, onFileUploadFailure);

  useEffect(() => {
    if (hasStarted.current) {
      return;
    }

    hasStarted.current = true;

    onStart();

    uploadImage(
      "cover",
      coverFile,
      {},
      () => {},
      () => {},
      () => {},
      () => {}
    );
  }, [gameId, coverFile, token, uploadImage]);

  return null;
};
